import { render, staticRenderFns } from "./StockOpnameList.vue?vue&type=template&id=2c950be2&"
import script from "./StockOpnameList.vue?vue&type=script&lang=js&"
export * from "./StockOpnameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports